let initialState = [];

export const notificationReducer = (state: any = initialState, action: any) => {
    let newState = state;
    let payload = action.payload;
    switch (action.type) {
        case 'ADD_NOTIFICATION':
            const notificationId = Math.floor(Math.random() * 100);
            const notification = { text: payload.text, type: payload.type, id: notificationId, timestamp: (new Date()).getTime() };
            newState.push(notification);
            return [...newState];
        case 'REMOVE_NOTIFICATION':
            const index = state.findIndex(n => n.id === payload.id);
            if (index > -1) {
                newState.splice(index, 1);
            }
            return [...newState];
    }

    return state;
}